import { render, staticRenderFns } from "./ParentRequestCode.vue?vue&type=template&id=68c11bac"
import script from "./ParentRequestCode.vue?vue&type=script&lang=js"
export * from "./ParentRequestCode.vue?vue&type=script&lang=js"
import style0 from "./ParentRequestCode.vue?vue&type=style&index=0&id=68c11bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports